const icons = {
  iconuserlogo: "user.png",
  iconarrowup: "arrowUp.png",
  iconarrowdown: "arrowDown.png",
};

export default icons;
